<template>
	<div class="battalion-poster-wrap">
		<div v-if="!isShow" class="poster-preview" :class="{ 'is-capturing': capturing }">
			<div class="poster-preview-content">
				<slot></slot>
			</div>
		</div>
		<div class="poster-bac" :class="[isFixHeight ? 'isFixHeight' : '']" v-if="isShow" @touchstart="handlerTouchstart"
			@touchmove="handlerTouchmove" @touchend="handlerTouchend">
			<img class="poster-image" :src="posterUrl" alt="">
			<i class="close-icon"></i>
		</div>
	</div>
</template>
<script>
/**
 * 海报弹窗容器
 *
 * 两阶段展示：
 * 1. isShow=false：渲染 slot 中的海报组件；capturing 时移出视口（loading 由 Toast.loading 负责）
 * 2. isShow=true：展示截图结果 posterUrl，支持长按保存
 */
export default {
	props: {
		posterUrl: {
			type: String,
			default: '',
		},
		isShow: {
			type: Boolean,
			default: () => false
		},
		// 与 posterState.isCapturing 绑定，capturing 时隐藏视口内半成品海报
		capturing: {
			type: Boolean,
			default: false,
		},
		isFixHeight: {
			type: Boolean,
			default: true
		},
		isStarMember: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			loop: 0,
			clickShow: false,
			longClickShow: false
		}
	},
	methods: {
		handlerTouchstart() {
			this.loop = setTimeout(() => {
				this.loop = 0
				// 执行长按要执行的内容


			}, 500) // 定时的时间
			return false
		},
		handlerTouchmove() {
			// 清除定时器
			clearTimeout(this.loop)
			this.loop = 0
		},
		handlerTouchend() {
			// 清除定时器
			clearTimeout(this.loop)
			if (this.loop !== 0) {
				// 单击操作
				this.$emit('OnCancelPoster', false)
			}
		},
		handleCancelPoster() {
			this.$emit('OnCancelPoster', false)
		},
	}
}
</script>
<style>
.van-popup--center {
	background: transparent;
}
</style>
<style lang="less" scoped>
.battalion-poster-wrap {
	position: relative;
	width: 100%;
}

.poster-preview {
	position: relative;
	width: 100%;
	overflow: hidden;
}

/* 截图准备阶段不展示半成品海报，避免用户看到图片自上而下加载 */
.poster-preview.is-capturing .poster-preview-content {
	position: absolute;
	left: -10000px;
	top: 0;
	width: 100%;
	max-width: 750px;
	opacity: 0;
	pointer-events: none;
}

.poster-bac {
	position: relative;
	width: 100%;
	z-index: 100;
	text-align: center;
	background: #00000050;
	display: flex;

	.close-icon {
		position: absolute;
		width: 64px;
		height: 64px;
		top: 40px;
		right: 10px;
		background: url('../../assets/images/winterGame/close.png') no-repeat center center;
		background-size: 100% 100%;
		&.star-member {
			top: 90px;
			right: 20px;
		}
	}
}

.poster-image {
	display: block;
	width: 100%;
}

.poster-bac.isFixHeight {
	height: 100vh;

	.poster-image {
		max-width: 100vw;
		margin: auto;
	}
}
</style>
